<app-hijack
    [users]="users | async"
    [searchResults]="searchResults | async"
    (partnerSelect)="getUsers($event)"
    (searchTerm)="search($event)">
</app-hijack>
